import { registerImplementations as registerParsers } from '~/lib/validators/identity-numbers/parsers';
import { registerImplementations as registerValidators } from '~/lib/validators/identity-numbers/validators';

export default defineNuxtPlugin(() => {
  registerValidators();
  registerParsers();
});
